import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const CountdownTimer = ({ initialSeconds = 60 }) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : initialSeconds);
    }, 1000);

    return () => clearInterval(timer);
  }, [initialSeconds]);

  return (
    <Typography variant="body2" sx={{ marginTop: 1 }}>
      Próxima verificação em: {seconds}s
    </Typography>
  );
};

export default CountdownTimer;
